// Estado de cliente da casca: a loja aberta, o papel de quem está nela e as
// lojas que a pessoa alcança. O resto é estado de servidor (TanStack Query).
// A loja escolhida fica lembrada no mesmo lugar que o legado usa
// (`borainbox_loja`), pra trocar de painel sem trocar de loja.
import { create } from 'zustand';
import type { LojaDoUsuario, Papel, QuemSou } from '../api/tipos';

export interface EstadoDaLoja {
  tenantId: string | null;
  papel: Papel;
  nomeDaLoja: string | null;
  lojas: LojaDoUsuario[];
  /** O servidor de tempo real, quando não é a própria origem (atrás do Hosting o WebSocket vai direto no Cloud Run). */
  tempoRealUrl: string | null;
  /**
   * Quem está logado é da plataforma (`BORAINBOX_SUPER_ADMIN_EMAILS` no back).
   * Vale em QUALQUER loja, inclusive na dele: é o que abre a lista de todas as
   * lojas. Numa loja de cliente, o papel dele é `suporte` — são duas coisas.
   */
  superAdmin: boolean;
  entrar(quem: QuemSou): void;
  trocar(tenantId: string): void;
}

const CHAVE = 'borainbox_loja';

export function lojaLembrada(): string | null {
  try { return localStorage.getItem(CHAVE); } catch { return null; }
}

export const useLoja = create<EstadoDaLoja>((set) => ({
  tenantId: null,
  papel: 'dono',
  nomeDaLoja: null,
  lojas: [],
  tempoRealUrl: null,
  superAdmin: false,
  entrar(quem) {
    try { localStorage.setItem(CHAVE, quem.tenantId); } catch { /* modo anônimo */ }
    set({ tenantId: quem.tenantId, papel: quem.papel, nomeDaLoja: quem.nomeDaLoja ?? null, lojas: quem.lojas, tempoRealUrl: quem.tempoReal?.url ?? null, superAdmin: quem.superAdmin === true });
  },
  trocar(tenantId) {
    try { localStorage.setItem(CHAVE, tenantId); } catch { /* modo anônimo */ }
    // Trocar de loja recarrega o painel inteiro: o WebSocket, os caches e as
    // permissões foram montados pra UMA loja — a mesma decisão do legado.
    location.href = '/app?tenant=' + encodeURIComponent(tenantId);
  },
}));

/**
 * Papéis que administram a loja: o menu de dono e as escritas dependem disto.
 * Desde 2026-10-08 o `suporte` entra: ele faz pelo cliente o que a dona faria
 * (menos apagar conta, conversa e pedido, que o servidor recusa).
 */
export const administra = (papel: Papel) => papel === 'dono' || papel === 'admin' || papel === 'suporte';

/**
 * O super admin numa loja que não é dele. Tudo o que o painel faria sozinho
 * ao abrir uma tela (instalar modelos, preencher a conta com o e-mail de quem
 * está logado, vincular uma instalação pendente) mudaria a loja do cliente só
 * por ele OLHAR — e é isto que essas telas perguntam antes.
 */
export const ehSuporte = (papel: Papel) => papel === 'suporte';
